import React, { useState, useRef } from 'react'
import Classes from '../Information.module.css'
import axios from 'axios'
import backend from '../../../../../../api';

export default function Identification({ handleNext, handleBack, formData, setFormData }) {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const uploadMedia = async (files) => {
    setUploading(true);
    try {
      const fd = new FormData();
      Array.from(files).forEach((f) => fd.append("file", f));
      const res = await backend.post('/user-information/upload/identification', fd);
      const url = res.data.url;
      setFormData({ ...formData, identificationUrl: url });
      return url;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setUploading(false);
    }
  };

  const handleFileChange = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    await uploadMedia(files);
  };

  return (
    <>
      <div className={Classes.infoCon} >
        <div>
          <h3>Identification</h3>
        </div>
        <div className={Classes.infoConMiddle} >
          <div className={Classes.textInstructions} >
            <h5 className={`${Classes.textBold} mb-10`} style={{ fontSize: '13px' }} >Some sites require a government issued ID in order to process the removal.</h5>
            <h5 className={Classes.text} > Examples include a Drivers License or Passport. </h5>
          </div>
          <input
            type='file'
            ref={fileInputRef}
            onChange={handleFileChange}
            hidden
          />
          <div className={Classes.flexAlign10} >
            <div className={Classes.uploadBtn} onClick={() => fileInputRef.current.click()} >
              <h5>{uploading ? 'Uploading...' : 'Choose File'}</h5>
            </div>
            <h5 className={Classes.noFileText} >{formData.identificationUrl ? 'File uploaded' : 'No file chosen (optional)'}</h5>
          </div>
          <h5 className={Classes.noFileText} style={{ marginTop: '1rem', marginBottom: '1rem' }} > Maximum file size: 10MB | Allowed formats: JPG, PNG, GIF, JPEG </h5>
          <h5 className={`${Classes.textBold}`} style={{ fontSize: '13px' }} >Please note: this step is optional but there may be data brokers that won’t allow deletions without a valid ID.</h5>
        </div>
        <div>
          <div className={Classes.flexEnd} >
            <div className={Classes.flexAlign10} >
              <button className={Classes.backBtn} onClick={handleBack} > <h5>Back</h5> </button>
              <button className={Classes.nextBtn} onClick={handleNext} > <h5>Next</h5> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}